import scrollToComponent from 'react-scroll-to-component';
import moment from 'moment';
import storage from 'local-storage-fallback';

export const scrollTo = (id, offset = 0) => {
  const navigation = document.querySelector(`#${id}`);
  scrollToComponent(navigation, { offset });
};

export const getEarlyBird = () => {
  return moment('09-10-2019 04:00:00 pm +08:00', 'MM-DD-YYYY hh:mm:ss a Z');
};

export const countdownCheck = () => {
  const attendeeTicketCount = storage.getItem('attendeeTicketCount') || 0;
  const startOn = attendeeTicketCount > 100 ? 1 : 0;

  let countdown;
  const dateFormat = 'MM-DD-YYYY hh:mm:ss a Z';
  // const yearAndTime = '2019 04:00:00 pm +08:00';

  // const priceUpdates = [
  //   249,
  //   264,
  //   279,
  //   294,
  //   300,
  //   319,
  //   339,
  //   359,
  //   379,
  //   399,
  //   424,
  //   474,
  //   499,
  //   599,
  //   624,
  //   649,
  //   674,
  //   699,
  // ];
  //
  // const priceIncreaseDates = [
  //   moment(`09-24-${yearAndTime}`, dateFormat),
  //   moment(`10-01-${yearAndTime}`, dateFormat),
  //   moment(`10-08-${yearAndTime}`, dateFormat),
  //   moment(`10-14-${yearAndTime}`, dateFormat),
  //   moment(`10-16-${yearAndTime}`, dateFormat),
  //   moment(`10-18-${yearAndTime}`, dateFormat),
  //   moment(`10-21-${yearAndTime}`, dateFormat),
  //   moment(`10-23-${yearAndTime}`, dateFormat),
  //   moment(`10-25-${yearAndTime}`, dateFormat),
  //   moment(`10-29-${yearAndTime}`, dateFormat),
  //   moment(`11-01-${yearAndTime}`, dateFormat),
  //   moment(`11-05-${yearAndTime}`, dateFormat),
  //   moment(`11-12-${yearAndTime}`, dateFormat),
  //   moment(`11-19-${yearAndTime}`, dateFormat),
  //   moment(`11-26-${yearAndTime}`, dateFormat),
  //   moment(`12-01-${yearAndTime}`, dateFormat),
  //   moment(`12-04-${yearAndTime}`, dateFormat),
  //   moment(`12-04-${yearAndTime}`, dateFormat),
  // ];

  const priceUpdates = [
    324,
    324,
    674,
    674,
  ];

  const priceIncreaseDates = [
    moment('11-28-2019 22:59:00 pm +08:00', dateFormat),
    moment('11-28-2019 22:59:00 pm +08:00', dateFormat),
    moment('12-03-2019 00:59:00 am +08:00', dateFormat),
    moment('12-04-2019 00:59:00 am +08:00', dateFormat),
  ];

  for (let i = startOn; i < priceIncreaseDates.length; i += 1) {
    if (!moment().isAfter(priceIncreaseDates[i])) {
      countdown = { date: priceIncreaseDates[i], price: priceUpdates[i], index: i };
      break;
    }
  }

  return countdown;
};

export const formatMoney = (price, c = 2, d = '.', t = ',') => {
  let n = price;
  const s = n < 0 ? '-' : '';
  const i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c), 10));
  const o = i.length;
  const j = o > 3 ? o % 3 : 0;

  return s + (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${t}`) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : '');
};

export function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}

export const isMobile = () => (/mobile|tablet/i.test(navigator.userAgent));

export const slugify = (string) => {
  let str = String(string).toString();
  str = str.replace(/^\s+|\s+$/g, '');
  str = str.toLowerCase();
  str = str.replace(/\s+/g, '-');
  return str;
};


export function objectToArray(obj) {
  return Object.keys(obj).map((key) => obj[key]);
}



// WEBPACK FOOTER //
// ./src/common/helpers.js